import React from "react";
import PageNavHeader from "../PageNavHeader";

const headingStyle = { fontFamily: "Inter, sans-serif", fontWeight: 800, fontSize: "clamp(24px, 7.5vw, 56px)", lineHeight: "110%", letterSpacing: "-0.04em" };

const PricingNavHeader = () => (
  <PageNavHeader mobileAlign="left">
    <h1 className="lowercase" style={headingStyle}>
      <span style={{ color: "#9747FF" }}>serve more, spend less -</span>
      <br className="hidden md:block" />
      <span style={{ color: "#FFFFFF" }}>with chat ordering that works for you</span>
    </h1>
  </PageNavHeader>
);

export default PricingNavHeader;
